import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { LayoutGrid } from 'lucide-react';
export function Nav() {
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 border-b ${scrolled ? 'bg-zinc-950/80 backdrop-blur-md border-white/10 py-3' : 'bg-transparent border-transparent py-5'}`} data-id="element-179">
      <div className="max-w-7xl mx-auto px-6 flex items-center justify-between" data-id="element-180">
        <div className="flex items-center gap-2" data-id="element-181">
          <div className="w-8 h-8 bg-white rounded-md flex items-center justify-center text-zinc-950" data-id="element-182">
            <LayoutGrid size={18} strokeWidth={2.5} data-id="element-183" />
          </div>
          <span className="font-semibold text-lg tracking-tight" data-id="element-184">
            Sheets2Board
          </span>
        </div>

        <nav className="hidden md:flex items-center gap-8 text-sm font-medium text-zinc-400" data-id="element-185">
          <a href="#features" className="hover:text-white transition-colors" data-id="element-186">
            Product
          </a>
          <a href="#compare" className="hover:text-white transition-colors" data-id="element-187">
            Compare
          </a>
          <a href="#pricing" className="hover:text-white transition-colors" data-id="element-188">
            Pricing
          </a>
          <a href="#docs" className="hover:text-white transition-colors" data-id="element-189">
            Docs
          </a>
        </nav>

        <div className="flex items-center gap-4" data-id="element-190">
          <button className="hidden md:block text-sm font-medium text-zinc-400 hover:text-white transition-colors" data-id="element-191">
            Sign in
          </button>
          <button className="bg-white text-zinc-950 px-4 py-2 rounded-md text-sm font-medium hover:bg-zinc-200 transition-colors" data-id="element-192">
            Get started
          </button>
        </div>
      </div>
    </header>;
}